<template>
    <div class="footer" id="contact">
        <div class="message-wrapper">
            <div class="cut"/>
            <div class=overlay />
            <div class="content">
                <h1>Get in touch</h1>
                <h2>If you have any questions just drop us a message.</h2>
                <div class="input-fields">
                    <div class="ne">
                        <input type="text" v-model="name" placeholder="Name"/>
                        <input type="text" v-model="email" placeholder="Email"/>
                    </div>
                    <textarea v-model="message" placeholder="Message">
                    </textarea>
                    <button @click="sendMail" class="submit">Send</button>
                </div>
            </div>
            <div class="cut-bottom"/>
        </div>
    </div>
</template>


<script>
export default {
  name: "Message",
  props: [],
  data(){
      return{
          name: '',
          email: '',
          message: ''
      }
  },
  mounted(){

  },
  methods:{
      sendMail(){
          if(this.name.length > 2 && this.email.length > 5 && this.valEmail(this.email) && this.message.length > 50){
            window.open("mailto:michael@wizykit.com?subject=Get In Touch From " + this.name + "&from=" + this.email + "&body=EMAIL: " + this.email + " MESSAGE:" + this.message);
          }
          else alert("Make sure you entered a name, your email (valid one) and you've written min. 50 letters.")
      },
      valEmail(email){
          var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
         return re.test(String(email).toLowerCase());
      }
  }
};
</script>

<style lang="scss" scoped>
.footer{
    position: relative;
    .message-wrapper{
        background-image: url('../assets/footerbackground.jpg');
        background-size: cover;
        height: 1000px;
        @media(min-width: 780px){
            height: 1400px;
        }
        @media(min-width: 2000px){
            height: 1900px;
        }
    }
    .overlay{
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0px;
      left: 0px;
      z-index: 1;
      background: rgb(54,209,220);
      background: linear-gradient(122deg, rgba(54,209,220,0.95) 20%, rgba(91,134,229,0.95) 95%);
    }
    .content{
        position: absolute;
        z-index: 2;
        color: white;
        text-align: center;
        top: 20%;
        @media(min-width: 780px){
            top: 30%;
        }
        width: 100%;
        h1{
            font-size: 2rem;
            font-weight: bold;
        }
        h2{
            padding: 2%;
            line-height: 1.5rem;
        }
    }
    .cut{
        position: absolute;
        height: 200px;
        width: 150%;
        background-color: white;
        z-index: 3;
        transform: rotate(-3deg) translateX(-20%);
        top: -10%;
        @media(min-width: 2000px){
            height: 200px;
            top: -6%;
        }
    }
    .cut-bottom{
        position: absolute;
        height: 150px;
        width: 150%;
        background-color: white;
        z-index: 3;
        transform: rotate(-3deg) translateX(-20%);
        bottom: -2%;
        @media(min-width: 2000px){
            height: 200px;
            bottom: -2%;
        }
    }
    input{
        font-size: 1.1rem;
        padding: 0.2%;
        margin: 1%;
        border-radius: 5px;
        height: 50px;
        outline: none;
        border: none;
        width: 90%;
        @media(min-width: 780px){
            width: 23.7%;
        }
    }
    textarea{
        font-size: 1.1rem;
        padding: 0.2%;
        margin: 1%;
        border-radius: 5px;
        outline: none;
        border: none;
        width: 90%;
        @media(min-width: 780px){
            width: 50%;
        }
        height: 300px;
    }
    button{
        display: block;
        margin: 0 auto;
        width: 90%;
        @media(min-width: 780px){
            width: 10%;
        } 
        height: 60px;
        outline: none;
        border: 1px solid white;
        border-radius: 50px;
        color: rgb(100,161,211);
        font-size: 1.2rem;
        font-weight: bold;
        transition: all .1s ease;
        transition-property: color, background-color;
        background-color: transparent;
        color: white;
        &:hover{
            transition: all .1s ease;
            transition-property: color, background-color;
            background-color: white;
            color: rgb(100,161,211);
            cursor: pointer;
          }
    }
}
</style>
